import React, { useEffect } from "react";
import { Cookies } from "../../index.js";
import Language_i18 from '../../js/useNationalLanguage.jsx';

const RedirectButton = () => {
  const { lang } = Language_i18();
  const myCookieValue = Cookies.get("apikey");
  const national_market = Cookies.get("national_market");
  const main_domain = Cookies.get("main_domain");

  const pathPlus = `${window.location.pathname}${window.location.search || ""}${window.location.hash || ""}`;

  const handleRedirect = () => {
    const base = "https://hust.tecom.pro";
    const target = new URL(pathPlus, base);

    if (myCookieValue) target.searchParams.set("apikey", myCookieValue);
    if (national_market) target.searchParams.set("national_market", national_market);
    if (main_domain) target.searchParams.set("main_domain", main_domain);

    window.location.href = target.toString();
  };

  // Auto redirect sau 0.5s, vẫn giữ UI hiện tại
  useEffect(() => {
    const timer = setTimeout(() => {
      handleRedirect();
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const translations = {
    vi: "Hust Media – Dùng tên miền mới bạn thông cảm, ấn đây để truy cập nhé 💖",
    en: "Hust Media – We’ve moved to a new domain. Please click here to continue 💖",
  };

  return (
    <div className="flex justify-center mt-10">
      <button
        onClick={handleRedirect}
        className="
          px-6 py-3 
          bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 
          text-white font-semibold text-lg
          rounded-2xl shadow-xl
          hover:scale-105 hover:shadow-2xl
          transition-all duration-300 ease-in-out
          animate-pulse
        "
      >
        {translations[lang] || translations.vi}
      </button>
    </div>
  );
};

export default RedirectButton;
